import React, {PureComponent} from "react";
import Dict from 'dict-lib';
import BUtils from "../../../../../utilities/BaseUtilities";
import {Grid, Row, InputGroup, FormGroup, FormControl, Button, Col} from 'react-bootstrap';
import stylesLexemeSenses from "../../../../../_css/dictionary/lexemeParts/lexemeSenses.module.css";
import {LexemePageContext} from "../../../LexemePageContext";
import {LexemeSenses} from "./LexemeSenses";
import {AdministrationUtilities} from "../../../../../administration/AdministrationHelper";
import {userService} from "../../../../../_redux/authentication/services/user.services";
import {LexemeUtilities} from "../../../editor/LexemeHelper";
import ReactTooltip from 'react-tooltip';
import FontAwesome from "react-fontawesome";
import stylesSCTree from "../../../../../dict-components/tree/SCTree.module.css";
import ReactDom from "react-dom";
import {SenseEncyclopedicInfos} from "../../../editor/senses/SenseComponents";

export class LexemeEncyclopedicInfos extends PureComponent {

    constructor(props) {
        super(props);

        this.isLogged = userService.isLogged();

        // Se l'HTML è già presente nel payload sincrono della pagina (valorizzato dal backend in
        // encyclopedic_infos_language_group[].html), lo mostriamo subito al primo render, senza
        // attendere componentDidMount/chiamate di rete: elimina il ritardo visivo rispetto al resto
        // della pagina (che viene renderizzato in sincrono dal genitore).
        // NOTA: nel costruttore `this.context` non è ancora assegnato da React (viene impostato solo
        // dopo che il costruttore termina), quindi il calcolo va protetto con un try/catch: se fallisce
        // si ricade sul comportamento precedente (html vuoto finché componentDidMount non lo recupera).
        var presetHtml;
        try {
            presetHtml = this._getPresetHtml(props);
        } catch (e) {
            presetHtml = undefined;
        }

        this.state = {
            html: typeof presetHtml !== 'undefined' ? presetHtml : '',
            hover: false,
            editing: false,
            tinyLoaded: false,
            bibliography: ''
        };

        this.isEditable = false;
        this._isMounted = false;
        this._launchEdit = this._launchEdit.bind(this);
        this._closeEdit = this._closeEdit.bind(this);
        this._resetTiny = this._resetTiny.bind(this);
    }

    _getPresetHtml(props) {
        if (typeof props.item.encyclopedic_infos === 'undefined') return undefined;

        var contextDescrLanguage = this.context ? this.context.descrLanguage : undefined;
        var code = typeof contextDescrLanguage !== 'undefined' ? contextDescrLanguage : AdministrationUtilities.getDescriptionLanguageByContext(this.context);
        var languageGroup = props.item.encyclopedic_infos.encyclopedic_infos_language_group || [];
        var matching = languageGroup.find(l => l.language === code);
        return matching && typeof matching.html !== 'undefined' ? matching.html : undefined;
    }

    componentDidMount() {
        this._isMounted = true;
        this._performLoadHtml();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    _performLoadHtml() {
        try {
            var contextDescrLanguage = this.context.descrLanguage;
            this.isEditable = LexemeUtilities.isPageEditable(this)
            var code = typeof contextDescrLanguage !== 'undefined' ? contextDescrLanguage : AdministrationUtilities.getDescriptionLanguageByContext(this.context);

            if (typeof this.props.item.encyclopedic_infos !== 'undefined') {
                // Il payload della pagina (letto in modo sincrono da getPage/getPages, incluso l'export
                // massivo) contiene già l'HTML completo per ogni lingua in encyclopedic_infos_language_group
                // (campo "html"). Usarlo direttamente evita la chiamata AJAX asincrona che, durante un
                // rendering/export di massa, non fa in tempo a risolversi e fa perdere il contenuto.
                var presetHtml = this._getPresetHtml(this.props);
                // In modalità export (rendering/export massivo) il componente viene smontato quasi
                // subito dopo la creazione per passare al componente della pagina successiva: lanciare
                // chiamate di rete asincrone qui è inutile (il risultato arriverebbe su un componente
                // già smontato, generando il warning "state update on an unmounted component") oltre
                // che dannoso per le performance dell'export stesso.
                var isExport = LexemeUtilities.isDisplayContextDictionaryExport(this);

                const bibliographyUrl = !isExport && typeof this.props.item.topic !== 'undefined' ? '/service/topics/getTopicBibliography/' + this.props.item.topic.id + '/' : '';

                if (typeof presetHtml === 'undefined') {
                    if (isExport) {
                        // Dati vecchi non ancora ri-salvati con la nuova logica: in export non c'è
                        // alternativa sincrona, quindi non tentiamo la chiamata di rete (il componente
                        // verrebbe smontato prima della risposta). Il testo resterà vuoto per questa voce.
                        var editDivExport = document.getElementById('ency_edit_' + this.props.item.ids);
                        if (editDivExport && editDivExport.innerHTML === '')
                            this._loadTiny();
                        return;
                    }

                    // Fallback: html non presente nel payload (dati non ancora ri-salvati con la nuova
                    // logica) -> si recupera come in precedenza tramite chiamata AJAX dedicata.
                    const urls = [
                        '/senses/getEncyclopedicInfos/' + this.props.item.encyclopedic_infos.id + '/' + code + '/',
                        bibliographyUrl
                    ];

                    Promise.all(urls.map(url => Dict.call(url))).then(result => {
                        if (!this._isMounted) return;
                        const html = result[0];
                        const bibliography = result[1].bibliography;
                        this.setState({html, bibliography}, () => {
                            var editDiv = document.getElementById('ency_edit_' + this.props.item.ids);
                            if (editDiv && editDiv.innerHTML === '')
                                this._loadTiny();
                        })
                    })
                } else {
                    // Impostiamo l'html nello stato solo se diverso da quello attuale, per evitare
                    // setState/ri-render a cascata inutili (possibile causa di loop infiniti se
                    // componentDidUpdate richiama questo metodo ad ogni render del genitore).
                    const loadTinyIfNeeded = () => {
                        var editDiv = document.getElementById('ency_edit_' + this.props.item.ids);
                        if (editDiv && editDiv.innerHTML === '')
                            this._loadTiny();
                    };

                    if (this.state.html !== presetHtml) {
                        this.setState({html: presetHtml}, loadTinyIfNeeded);
                    } else {
                        loadTinyIfNeeded();
                    }

                    // La bibliografia del topic (usata solo nel tooltip) resta secondaria e asincrona:
                    // non deve bloccare la visualizzazione del testo enciclopedico principale. In export
                    // viene saltata del tutto (bibliographyUrl è già '' in quel caso).
                    if (bibliographyUrl !== '') {
                        Dict.call(bibliographyUrl).then(result => {
                            if (!this._isMounted) return;
                            this.setState({bibliography: result.bibliography});
                        })
                    }
                }
            } else {
                this._loadTiny();
            }
        } catch (e) {
            this.setState({html: 'errore di recupero testo'});
        }
    }

    /*shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.state.html !== nextState.html || this.state.hover !== nextState.hover || this.state.editing !== nextState.editing || this.state.tinyLoaded !== nextState.tinyLoaded;
    }*/

    /*shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.state.html !== nextState.html || this.state.hover !== nextState.hover || this.state.editing !== nextState.editing || this.state.tinyLoaded !== nextState.tinyLoaded || this.props.item.topic !== nextProps.item.topic;
    }*/

    componentDidUpdate(prevProps, prevState) {
        if (typeof this.props.item.encyclopedic_infos === 'undefined') {
            this.setState({html: ''}, () => {
                this._resetTiny('')
            });
        //} else if (((this.state.bibliography === '' || typeof this.state.bibliography === 'undefined') && typeof this.props.item.topic !== 'undefined') || prevProps.item.topic.id !== this.props.item.topic.id) {
        } else {
            // Confronto per id (non per riferimento d'oggetto): il genitore può ricreare l'oggetto
            // `item`/`topic` ad ogni render pur mantenendo lo stesso contenuto. Confrontare i riferimenti
            // (prevProps.item.topic !== this.props.item.topic) richiamerebbe _performLoadHtml() ad ogni
            // render, causando un setState sincrono a cascata e un "Maximum update depth exceeded".
            var prevTopicId = prevProps.item.topic ? prevProps.item.topic.id : undefined;
            var currTopicId = this.props.item.topic ? this.props.item.topic.id : undefined;
            if (prevTopicId !== currTopicId) {
                this._performLoadHtml();
            }
        }
    }

    _loadTiny() {
        //ReactDom.unmountComponentAtNode(document.getElementById('ency_edit_' + this.props.item.ids));
        ReactDom.render(<SenseEncyclopedicInfos item={this.props.item}
                                                context={this.context}
                                                html={this.state.html}
                                                callbackParent={(newState, html) => {
                                                    this._closeEdit(html);
                                                }}
                                                callbackParentSaveOnly={(newState, html) => {
                                                    if (html !== null)
                                                        this._resetTiny(html);
                                                }}

        />, document.getElementById('ency_edit_' + this.props.item.ids), () => {
            this.setState({tinyLoaded: true});
        });
    }

    _resetTiny(html) {
        ReactDom.unmountComponentAtNode(document.getElementById('ency_edit_' + this.props.item.ids));
        this.setState({html}, () => {
            this._loadTiny();
        })
        //this._performLoadHtml();
    }

    _launchEdit() {
        ReactDom.unmountComponentAtNode(document.getElementById('ency_edit_' + this.props.item.ids));
        this.setState({editing: true}, () => {
            this._loadTiny();
        });
    }

    _closeEdit(html) {
        //ReactDom.unmountComponentAtNode(document.getElementById('ency_edit_' + this.props.item.ids));
        this.setState({editing: false, hover: false}, () => {
            if (html !== null)
                this._resetTiny(html);
        });
    }

    render() {
        const isExport = LexemeUtilities.isDisplayContextDictionaryExport(this);

        return <>
            {this.state.tinyLoaded && (this.props.item.encyclopedic_infos === 'undefined' || this.state.html === '') && !this.state.editing ?
                <Button onClick={() => {
                    this.setState({editing: true});
                }}>Aggiungi informazione enciclopedica</Button> : ''}
            {!isExport && (typeof this.props.item.topic === 'undefined' || !this.state.tinyLoaded) ? "" :
                <>
                    <div
                        className={BUtils.joinClasses(stylesLexemeSenses['senseItemTopic'], stylesLexemeSenses['senseEncyItemTopic'])}
                        data-tip data-for='encyclopedic_infos-tooltip-description'
                    >{this.props.item.topic.extendedUniqueDescription}</div>
                    <ReactTooltip id='encyclopedic_infos-tooltip-description' type='dark' delayShow={150}>
                        <div dangerouslySetInnerHTML={{__html: this.state.bibliography}}/>
                    </ReactTooltip></>}
            <div id={'ency_edit_' + this.props.item.ids}
                 className={BUtils.joinClasses(stylesLexemeSenses['encyclopedic_infos_editor_container'], stylesLexemeSenses['encyclopedic_infos_editor_container__' + this.state.editing])}/>
            {!this.state.editing && this.isLogged ? <div
                className={BUtils.joinClasses(stylesLexemeSenses['encyclopedic_infos_container__pencil'], stylesLexemeSenses['encyclopedic_infos_container__pencil__' + this.state.hover])}>
                <FontAwesome name={'pencil'} style={{fontSize: '20px', color: '#c1c1c1'}}/>
            </div> : ''}
            {!this.state.editing ? <div
                onMouseOver={() => {
                    this.setState({hover: true})
                }}
                onMouseOut={() => {
                    this.setState({hover: false})
                }}

                onClick={() => {
                    if (this.isLogged)
                        this._launchEdit();
                }}
                className={BUtils.joinClasses(stylesLexemeSenses['encyclopedic_infos_container'], stylesLexemeSenses['encyclopedic_infos_container_editor__' + this.isEditable])}
                dangerouslySetInnerHTML={{__html: this.state.html}}/> : ''}
        </>
    }
}

LexemeEncyclopedicInfos.contextType = LexemePageContext;